import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { LswTokenService } from "src/app/services/lsw-token.service";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { map, take } from "rxjs/operators";
@Component({
  selector: "app-user-profile-popup",
  templateUrl: "./user-profile-popup.component.html",
  styleUrls: ["./user-profile-popup.component.scss"],
})
export class UserProfilePopupComponent implements OnInit {
  userDetails: any;
  static close: any;
  constructor(
    private matDialogRef: MatDialogRef<UserProfilePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private authService: AuthService,
    private lswTokenService: LswTokenService,
    private angularFirestore: AngularFirestore,
    public angularFireFunctions: AngularFireFunctions,
    private matDialog: MatDialog
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    const userId = this.data;
    const isEmpty = (val: any) => val === undefined || val === null || !(Object.keys(val) || val).length;
    try {
      this.authService.getUserInfoCardList(this.data)?.subscribe((ref: any) => {
        if (!isEmpty(ref)) {
          this.userDetails = ref;
          //this.userDetails["follow"] = "follow";
        } else {
          // V1
          /* const getUserDetails = this.angularFireFunctions.httpsCallable("userInfoCard");
          getUserDetails(userId) */
          // V2
          this.authService.getV2CloudFunction("userinfocardv2", userId)
            .pipe(take(1))
            ?.subscribe((res: any) => {
              this.userDetails = res;
              //this.userDetails["follow"] = "follow";
            });
        }
      });
    } catch (err) {
      return false;
    }
  }

  openPeepsoProfile(url: string, ownerId: any) {
    try {
      if (url && url.search("web.lottosocial.com") < 0) {
        url = "https://web.lottosocial.com/" + url;
      }
      this.lswTokenService.openPepsoUrlView({ url: url, ownerId: ownerId, member_user_id: this.data });
    } catch (err) {
      return false;
    }
  }

  /*   followFriend(url: string, followStatus: string) {
      this.userDetails["follow"] = followStatus == "following" ? "follow" : "following";
      url = url + "&followstatus=" + followStatus;
      this.openPeepsoProfile(url, '')
    } */

  openPeepsoMessages(url: string) {
    try {
      if (url && url.search("web.lottosocial.com") < 0) {
        url = "https://web.lottosocial.com/" + url;
      }
      this.lswTokenService.openPepsoUrlView({ url: url, message: "message" });
    } catch (err) {
      return false;
    }
  }

  closePopup() {
    this.matDialog.closeAll();
  }
}
